import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';
import { CategoryType, ProcessStatus, YesNo } from 'interfaces';

export type ProductCategory = {
  product_category_id?: number; // 상품 카테고리 idx
  commission_rate?: number; // 수수료
  parents_id?: number; // 상위 idx
  shop_information_id?: number; // 쇼/브/매/지 idx
  product_category_name?: string; // 상품 카테고리명
  application_status?: (typeof ProcessStatus)[keyof typeof ProcessStatus]; // 상태
  type?: (typeof CategoryType)[keyof typeof CategoryType]; // 타입
  order?: number; // 노출 순서
  is_show?: (typeof YesNo)[keyof typeof YesNo]; // 노출여부
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] ProductCategory
   * --
   */
  getProductCategories: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_PRODUCT_CATEGORY, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] ProductCategory
   * --
   */
  getProductCategory: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_PRODUCT_CATEGORY, {
        product_category_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ProductCategory
   * --
   */
  createProductCategory: async (body: ProductCategory) => {
    try {
      const res = await $http.post(APIConstant.CREATE_PRODUCT_CATEGORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] ProductCategory
   * --
   */
  updateProductCategory: async (body: ProductCategory) => {
    try {
      const { product_category_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_PRODUCT_CATEGORY, {
        product_category_id: product_category_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] ProductCategory
   * --
   */
  deleteProductCategory: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.DELETE_PRODUCT_CATEGORY, {
        product_category_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] ProductCategory
   * --
   */
  upsertProductCategory: async (body: ProductCategory[]) => {
    try {
      const res = await $http.post(APIConstant.UPSERT_PRODUCT_CATEGORY, body);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
